import { createFileRoute } from '@tanstack/react-router';
import { RelatorioEstoqueMinimo } from '@/features/relatorio/page/estoque/estoque-minimo/RelatorioEstoqueMinimo';

export const Route = createFileRoute('/a/relatorio/estoque/estoque-minimo')({
    component: RelatorioEstoqueMinimo,
});
